import { useAuthContext } from '@inbox-demo-nx/contexts';
import { SupportAppMessageTypes } from '@inbox-demo-nx/web-demo-constants';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';
import { Platform } from 'react-native';

export function useSupportAppWindowMessageHandler() {
  const navigation = useNavigation<NavigationProp<any>>();
  const { initializeCurrentUser } = useAuthContext();
  useEffect(() => {
    if (Platform.OS === 'web') {
      const eventHandler: WindowEventHandlers['onmessage'] = (event) => {
        if (event.data === SupportAppMessageTypes.START_CONVERSATION) {
          navigation.navigate('Chat');
        }
        if (event.data === SupportAppMessageTypes.RESET) {
          initializeCurrentUser();
        }
      };
      window.addEventListener('message', eventHandler);
      return () => {
        window.removeEventListener('message', eventHandler);
      };
    }
    return;
  }, [initializeCurrentUser, navigation]);
}

export default useSupportAppWindowMessageHandler;
